<template>
   
        <div class="process flex-center-lr">
            <div v-for="item in processList" :key="item.value" :class="[{'process-after':value>item.value,'process-line':value==item.value}]"><div>{{item.value}}</div><p>{{ item.name }}</p></div>
        </div>
    
</template>

<script>
export default {
    props:{
        value:{
            type: Number,
            default:1,
        },
        processList:{
            type:Array,
            default: []
        }
    }
}
</script>

<style lang="scss" scoped>
.process {
    height: 6px;
    background: #E1E1E1;
    border-radius: 4px;
    margin: 10px 0 32px;
    &>div{
        width: 150px;
        height: 100%;
        position: relative;
        border-radius: 4px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        text-align: center;
        &>div{
            text-align: center;
            line-height: 24px;
            color: #fff;
            background-color: #E1E1E1;
            border-radius: 12px;
            position: absolute;
            height: 24px;
            width: 24px;
            top: -9px;
            left: 50%;
            margin-left: -12px;
            z-index: 2;
        }
        &>p{
            margin-top: 20px;
        }
    }
    & &-after{
        background: #7FAFFF;
        color: #7FAFFF;
        z-index: 3;
        &>div{
            background: #7FAFFF;
        }
    }
    & &-line{
        background: #0060FF;
        color: #0060FF;
        &>div{
            background: #0060FF;
        }
        &::after{
            content:'';
            width: 6px;
            height: 6px;
            background: #0060FF;
            position: absolute;
            top: 0;
            left: -4px;
        }
    }
}
</style>